import { useEffect, useRef } from 'react'
import { InputFileDetail } from 'components/atoms/InputFileDetail/InputFileDetail'
import { Snackbar } from 'components/atoms/Snackbar/Snackbar'
import { useDownloadCriteriaFile } from '../../hooks/useDownloadCriteriaFile'

interface CriteriaFileDetailProps {
    groupId: number
    criteriaId: number
    name: string
    valueKey: 'postal_code_list' | 'hs_code'
    criteria_quantity: number
}

interface SnackbarHandle {
    showModal: (value: boolean) => void
}

export const CriteriaFileDetail = ({
    groupId,
    criteriaId,
    name,
    valueKey,
    criteria_quantity,
}: CriteriaFileDetailProps) => {
    const { download, isDownloading, error } = useDownloadCriteriaFile(
        groupId,
        criteriaId
    )
    const snackbarRef = useRef<SnackbarHandle>(null)

    useEffect(() => {
        if (error !== null) {
            snackbarRef.current?.showModal(true)
        }
    }, [error])

    return (
        <>
            <InputFileDetail
                name={name}
                valueKey={valueKey}
                onDownload={download}
                isDownloading={isDownloading}
                criteria_quantity={criteria_quantity}
            />
            <Snackbar
                ref={snackbarRef}
                title="Error"
                description={error ?? ''}
                state="error"
                closeAction
                time={4000}
            />
        </>
    )
}
